import { DOCUMENT } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Le lien d'evitement : premier element focalisable d'une page (RGAA 12.7).
 *
 * Invisible tant qu'il n'a pas le focus, il permet a qui navigue au clavier de
 * sauter ce qui precede le contenu principal plutot que de le retraverser a
 * chaque ecran.
 *
 * ## Pourquoi un composant, et pas trois lignes recopiees
 *
 * Son activation est INTERCEPTEE, et la raison n'est pas evidente : dans une
 * application Angular, laisser le navigateur suivre `#contenu-principal`
 * change l'URL, le routeur y cherche une route, n'en trouve pas, et renvoie au
 * tableau de bord. Releve en recette : « ca focus bien le contenu MAIS
 * recharge la page, et ca renvoie constamment au dashboard ».
 *
 * Ce piege se paie une fois. Recopie sur un deuxieme ecran, il serait corrige
 * sur l'un et pas sur l'autre le jour ou il bouge -- c'est pourquoi l'ajout du
 * lien sur la page de connexion a donne lieu a cette extraction plutot qu'a un
 * copier-coller.
 *
 * ## Le `href` reste
 *
 * Il fait de cet element un LIEN -- annonce comme tel, et qui fonctionnerait
 * encore sans JavaScript. Seul son comportement par defaut est remplace.
 */
@Component({
  selector: 'app-lien-evitement',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './lien-evitement.component.html',
})
export class LienEvitementComponent {
  private document = inject(DOCUMENT);

  /** L'identifiant de la zone a atteindre. */
  cible = input<string>('contenu-principal');

  allerAuContenu(evenement: Event): void {
    evenement.preventDefault();
    this.document.getElementById(this.cible())?.focus();
  }
}
